var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEducationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.243,
    height: 51.669,
    viewBox: "0 0 80.243 51.669",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_85f83544ccb59d8007e9d73f1a18400a",
    "data-name": "85f83544ccb59d8007e9d73f1a18400a",
    transform: "translate(-7.685 -58.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M136.6,144.567a1.26,1.26,0,0,0-1.408-1.249l-42.816,5.041a1.261,1.261,0,0,0-1.113,1.252v11.343c0,4.974,14.26,6.3,22.686,6.3s22.686-1.328,22.686-6.3v0Z",
    transform: "translate(-66.139 -66.917)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M222.52,167.474H199.834v18.9h.035c8.206,0,21.938-1.26,22.651-5.92Z",
    transform: "translate(-152.062 -86.04)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M85.372,70.691,53.12,59.633a16.454,16.454,0,0,0-10.627,0L10.241,70.691a3.78,3.78,0,0,0,0,7.153L42.493,88.9a16.455,16.455,0,0,0,10.627,0L85.373,77.844a3.78,3.78,0,0,0,0-7.153Z",
    fill: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M219,154.125a1.26,1.26,0,0,1-1.26-1.26V136.4a1.261,1.261,0,0,0-.852-1.193l-22.243-7.626a1.26,1.26,0,1,1,.817-2.384l22.243,7.626a3.781,3.781,0,0,1,2.555,3.577v16.468A1.26,1.26,0,0,1,219,154.125Z",
    transform: "translate(-147.28 -52.527)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M306.316,263.392H303.8a1.26,1.26,0,0,1-1.26-1.26V254.57a2.521,2.521,0,0,1,2.52-2.521h0a2.52,2.52,0,0,1,2.521,2.521v7.562A1.26,1.26,0,0,1,306.316,263.392Z",
    transform: "translate(-233.338 -152.971)",
    fill: "#d7dbdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M308.576,201.373l.028-.016-.007-3.45c0,.02-.018.042-.021.061Z",
    transform: "translate(-238.118 -110.125)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 5.041,
    cy: 2.521,
    rx: 5.041,
    ry: 2.521,
    transform: "translate(42.765 71.351)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/educationIcon.61da5f6b6578bc2ac3dd1f344e691c9f.svg";
export { ForwardRef as ReactComponent };